"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ToolOffset = void 0;
/*
 * © 2017 Renishaw plc. All rights reserved.
 * This source file is the confidential property and copyright of Renishaw plc
 * Reproduction or transmission in whole or in part, in any form or
 * by any means, electronic, mechanical or otherwise, is prohibited
 * without the prior written consent of the copyright owner.
 */
const react_1 = __importDefault(require("react"));
const Base_1 = require("./Base");
const ToolOffset = ({ colour = "#E6E6E6", size = 16, title = "Tool Offset" }) => (react_1.default.createElement(Base_1.Base, { size: size, fill: colour },
    react_1.default.createElement("title", null, title),
    react_1.default.createElement("path", { d: "M10 11.1V16H6v-1l4-3.9zM10 7v1.9l-4 4V11l4-4zm0-3.9v1.8l-4 4V7l4-3.9zM6 0h4v.9l-4 4V0z" })));
exports.ToolOffset = ToolOffset;
//# sourceMappingURL=ToolOffset.js.map